import { useRemissionTabeOrderByDate } from "../../../hooks/remission/useRemissionTableOrderByDate.hook";
import Table from "./table";

export default function RemissionInfo(){

    // TODO Create hook and pass data to table
    const hook = useRemissionTabeOrderByDate();

    return(
        <Table hook={hook} />
    );

}